<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<br/><p style="text-indent:00em;">P. A. Gillis has written stories, plays and poems all her life. She performs her poems at clubs and poetry gatherings, and inserts them on ‘Poems Tuppence Each’.</p>
<br/><p style="text-indent:00em;">She has had a play professionally produced and another given a rehearsed reading at a festival, two poems in an anthology and <em>The Great Neptune Bar Mystery</em> published in 2020, hopefully cheering people during and after the pandemic.</p>
<br/><p style="text-indent:00em;"><em>The Great Saint Controversy</em> is being written now.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?202edba9